module.exports = __webpack_public_path__ + "img/组 13.801315ca.png";